import { createRequest } from "helpers/tools";

export const userCheck = async (token) => {
    const response = await createRequest({
        suffix: `user-check`,
        method: "post",
        payload: { token },
        handleError: false,
    });
    if (response.status) {
        const userToken = response.data && response.data.token;
        window.localStorage.setItem("token", userToken);
        return {
            status: true,
            data: userToken,
        };
    }
    return {
        status: false,
    };
};
